<template>
  <div class="" id="pageTop" style="padding:1rem 1rem 10rem">
    <div class="row">
      <div class="col-12 col-md-3"></div>
      <div class="col-12 col-md-6">
        <div class="col-12 mb-4" align="center">
          <img class="conf-logo" :src="`https://firebasestorage.googleapis.com/v0/b/district-conference-7030.appspot.com/o/${confId}%2F${confInfo.conflogo}?alt=media`" />
        </div>
        <div class="col-12 card text-white"  :class="confInfo.conftype === 'rotaract' ? 'bg-danger' : 'bg-primary'">
          <div class="card-body">
            <h4 class="">
              {{confInfo.confname}}
            </h4>
            <h6>
              <small>{{confInfo.confloc}} <br/>{{confInfo.confdate}} </small>
            </h6>
            <hr size="1"/>
            <p>
              <small>Conference Secretary:</small>
              <br/><span class="h5">{{confInfo.confsec}}</span>
              <br/>{{confInfo.confemail}}
              <br/>{{confInfo.confphone}}
            </p>
          </div>
        </div>
        <div class="my-4" align="center">
          <button class="btn btn-block btn-lg btn-warning text-white" @click="$router.push(`/${confId}/registrations/add`)">Register now for <br/>{{confInfo.confname}}</button>
        </div>
        <div class="card border-primary text-primary my-4" align="center">
          <div class="card-body">
            Time to conference
            <Countdown class="my-3" :end="confInfo.confstartdate" v-if="confInfo.confstartdate"></Countdown>
            <h6>
              {{confInfo.confdate}} <br/>{{confInfo.confloc}}
            </h6>
          </div>
        </div>
        
        <!-- <div class="col-12 card card-body border-primary">
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/XpCYa1AxB9w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div> -->
      </div>
      <div class="col-12 col-md-3"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Countdown from 'vuejs-countdown'
const fb = require("../firebaseConfig")
export default {
	name: 'Home',
	components: {
		Countdown
	},
  computed:{
    confId(){
      return this.$store.state.confId
    },
    /* confInfo(){
      let confId = this.$route.params.id
      console.log(confId)
      let confInfo = this.$store.state.confList.filter((conf)=> conf.id===confId)
      console.log(confInfo[0].data)
      return confInfo[0].data
    }, */
  },
	data(){
		return{
      confInfo: {}
		}
	},
	methods:{

	},
	mounted(){
    let confId = this.$route.params.id
    fb.confeventsCollection.doc(confId).onSnapshot((doc)=>{
      if(doc.exists){
        this.confInfo = doc.data()
        this.$store.dispatch("fetchConfProfile", confId)
      }else{
        this.$router.push("/")
      }
    }) 
	},
}
</script>
